import React from "react";
import resumeData from "../data/resume.json";
import skillsData from "../data/skills.json";

const SkillBar = ({ skill }) => (
  <div className="col-md-6 wow fadeInUp">
    <p className="fw-500 text-start mb-2">
      {skill.name} <span className="float-end">{skill.percent}%</span>
    </p>
    <div className="progress progress-sm mb-4">
      <div
        className="progress-bar"
        role="progressbar"
        style={{ width: `${skill.percent}%` }}
        aria-valuenow={skill.percent}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  </div>
);

const SkillSection = ({ section }) => (
  <>
    <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">{section.title}</h2>
    {section.groups.map((group) => (
      <div key={group.label} className="mb-2">
        <h3 className="text-5 fw-600 text-muted mb-3 wow fadeInUp">{group.label}</h3>
        <div className="row gx-5">
          {group.skills.map((skill) => (
            <SkillBar key={skill.skill_id} skill={skill} />
          ))}
        </div>
      </div>
    ))}
  </>
);

const Resume = () => {
  const { technical_stack, capabilities } = skillsData;
  const { experience, education, seminars } = resumeData;

  return (
    <section id="resume" className="section">
      <div className="container">
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        <div className="row g-5 mt-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experience.map((value) => (
                <div key={value.id}>
                  <h3 className="text-5">{value.title}</h3>
                  <p className="mb-2">
                    {value.place} / {value.yearRange}
                  </p>
                  <p className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {value.desc}
                  </p>
                  <hr className="my-4" />
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {education.map((value) => (
                <div key={value.id}>
                  <h3 className="text-5">{value.title}</h3>
                  <p className="mb-2">
                    {value.place} / {value.yearRange}
                  </p>
                  {value.desc && <p className="text-muted">{value.desc}</p>}
                  <hr className="my-4" />
                </div>
              ))}
            </div>

            <div className="col-lg-6 wow fadeInUp">
              <h2 className="text-7 fw-600 mb-4 pb-2">My Seminars</h2>
              <div className="border-start border-2 border-primary ps-3">
                {seminars.map((value) => (
                  <div key={value.id}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.year}
                    </p>
                    <hr className="my-4" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <SkillSection section={technical_stack} />
        <SkillSection section={capabilities} />
      </div>
    </section>
  );
};

export default Resume;
